import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import UIEventBus from '../EventBus';
import InfoOverlay from './InfoOverlay';

interface InterfaceUIProps {}

const InterfaceUI: React.FC<InterfaceUIProps> = ({}) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(true);
    const interfaceRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // the name shows as soon as the room is in (no 'click anywhere' step any more)
        const unsubLoaded = UIEventBus.on('loadingScreenDone', () => {
            setLoading(false);
            setVisible(true);
        });

        const element = document.getElementById('ui-interactive');
        if (element) {
            // @ts-ignore
            interfaceRef.current = element;
        }

        return () => unsubLoaded();
    }, []);

    useEffect(() => {
        const unsubEnter = UIEventBus.on('enterMonitor', () => {
            setVisible(false);
            if (interfaceRef.current) {
                interfaceRef.current.style.pointerEvents = 'none';
            }
        });
        const unsubLeft = UIEventBus.on('leftMonitor', () => {
            setVisible(true);
            if (interfaceRef.current) {
                interfaceRef.current.style.pointerEvents = 'auto';
            }
        });
        return () => {
            unsubEnter();
            unsubLeft();
        };
    }, []);

    return !loading ? (
        <motion.div
            initial="hide"
            variants={vars}
            animate={visible ? 'visible' : 'hide'}
            style={styles.wrapper}
            className="interface-wrapper"
            id="prevent-click"
        >
            <InfoOverlay visible={visible} />
        </motion.div>
    ) : (
        <></>
    );
};

const vars = {
    visible: {
        opacity: 1,
        transition: {
            duration: 0.9,
            ease: 'easeOut',
        },
    },
    hide: {
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: 'easeOut',
        },
    },
};

interface StyleSheetCSS {
    [key: string]: React.CSSProperties;
}

const styles: StyleSheetCSS = {
    wrapper: {
        width: '100%',
        display: 'flex',
        position: 'absolute',
        boxSizing: 'border-box',
    },
};

export default InterfaceUI;
